export class StorageManager {
  private static keyFlag = 'sx_kk';
  private static instance: StorageManager;

  public static getInstance(): StorageManager {
    if (!StorageManager.instance) {
      StorageManager.instance = new StorageManager();
    }
    return StorageManager.instance;
  }

  private static conversionKey(key: string): string {
    return `${StorageManager.keyFlag}_${key}`;
  }

  get<T>(key: string): T | null {
    const relKey = StorageManager.conversionKey(key);
    let value: string | unknown = localStorage.getItem(relKey);
    try {
      value = JSON.parse(value as string) || null;
    } catch (e) {
      // nothing to do
    }
    return value as T;
  }

  getKey(index: number): string | null {
    return localStorage.key(index);
  }

  get length(): number {
    return localStorage.length;
  }

  set<T>(key: string, value: T): void {
    const relKey = StorageManager.conversionKey(key);
    localStorage.setItem(relKey, JSON.stringify(value));
  }

  clear(): void {
    localStorage.clear();
  }
}
